import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingStates } from '../../../../../constants/booking-states';
import { Schedule } from '../../../elements-forms/schedule';
import { Tooltip } from '../../../elements-tooltip/tooltip';
import { checkIsGuestView } from '../utils/check-is-guest-view';
import { BookingSummaryItem } from './BookingSummaryItem';

const getDateTimeLabel = (booking) => {
  let dateTimeLabel = '';
  if (booking?.obj_state === BookingStates.REQUESTED) {
    dateTimeLabel = (
      <FormattedMessage
        id='inbox.summary_props.requested'
        defaultMessage='Requested'
      />
    );
  } else if (booking?.obj_state === BookingStates.INQUIRED) {
    dateTimeLabel = (
      <FormattedMessage
        id='inbox.summary_props.inquired'
        defaultMessage='Inquired'
      />
    );
  } else if (booking?.obj_state === BookingStates.OFFER_SUBMITTED) {
    dateTimeLabel = (
      <FormattedMessage id='inbox.summary_props.offer' defaultMessage='Offer' />
    );
  }
  return dateTimeLabel;
};

export const BookingSummaryDateTime = ({
  currentBooking,
  pendingBooking,
  profile
}) => {
  const isGuestView = checkIsGuestView(profile, currentBooking);
  const datetimeUpdated =
    !isEmpty(pendingBooking) &&
    !isEqual(currentBooking.schedule, pendingBooking.schedule);

  return (
    <BookingSummaryItem
      testingId='booking-summary-datetime'
      label={
        <span className='capitalize'>
          <FormattedMessage
            id='inbox.summary_props.date_and_time'
            defaultMessage='{date} Date & Time {tip}'
            values={{
              date: getDateTimeLabel(currentBooking),
              tip: currentBooking?.obj_state === BookingStates.INQUIRED &&
                isGuestView && (
                  <span className='margin-sm-left'>
                    <Tooltip
                      tooltip={{
                        content: (
                          <FormattedMessage
                            id='inbox.summary_props.adjust_date'
                            defaultMessage='You can adjust your date, time, or attendee count when you start your booking.'
                          />
                        ),
                        settings: {
                          placement: 'top',
                          fontSize: '18px'
                        },
                        className: 'inline-block'
                      }}
                    />
                  </span>
                )
            }}
          />
        </span>
      }
      updatedContent={
        datetimeUpdated && (
          <Schedule
            timeZoneId={pendingBooking?.timezone?.id || 'America/Los_Angeles'}
            schedule={pendingBooking?.schedule}
            flexible={
              pendingBooking?.flexible_date_time &&
              pendingBooking?.obj_state === BookingStates.INQUIRED
            }
          />
        )
      }
    >
      <Schedule
        timeZoneId={currentBooking?.timezone?.id || 'America/Los_Angeles'}
        schedule={currentBooking?.schedule}
        flexible={
          currentBooking?.flexible_date_time &&
          currentBooking?.obj_state === BookingStates.INQUIRED
        }
      />
    </BookingSummaryItem>
  );
};

BookingSummaryDateTime.propTypes = {
  currentBooking: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  pendingBooking: PropTypes.object
};
